'use client'

import { useLogoState } from './logoCache'

// A brand's mark: the platform's own registered logo (platform.logo_url,
// edited in Manage Platforms) in a small tile, shown only once the image is
// actually loaded (shell/logoCache.ts preloads every platform's logo when
// the catalog arrives). Until then, when the logo fails, and for a platform
// without one, the mark is the brand's initial capital in the UI font on a
// neutral tile -- plain, nothing stylised, never an empty box. SIBS scopes
// to the mbway platform and shares its mark.

function initial(code: string, label?: string): string {
  const key = code.toLowerCase()
  if (key === 'mbway' || key === 'sibs') return 'MB'
  return (label ?? code).trim().charAt(0).toUpperCase() || '?'
}

export function PlatformMark({ code, label, logoUrl, size = 'sm', className = '' }: { code: string; label?: string; logoUrl?: string | null; size?: 'sm' | 'md'; className?: string }) {
  const box = size === 'md' ? 'h-[29px] w-[29px] rounded-[6px]' : 'h-5 w-5 rounded-[4px]'
  const logo = useLogoState(logoUrl)
  if (logoUrl && logo === 'loaded') {
    return (
      <span aria-hidden className={`inline-grid shrink-0 place-items-center overflow-hidden bg-card ${box} ${className}`}>
        <img src={logoUrl} alt="" className="h-full w-full object-contain" />
      </span>
    )
  }
  const text = initial(code, label)
  const font = size === 'md' ? (text.length > 1 ? 'text-[11px]' : 'text-[15px]') : (text.length > 1 ? 'text-[8px]' : 'text-[11px]')
  return (
    <span aria-hidden className={`inline-grid shrink-0 place-items-center border border-border bg-secondary font-semibold leading-none text-foreground ${box} ${font} ${className}`}>
      {text}
    </span>
  )
}
